import React from 'react';
import { styled } from '@mui/material/styles';
import { SvgIconProps } from '@mui/material';

import { Typography } from '.';

const Container = styled('div')`
  padding-top: 100px;
  padding-bottom: 100px;
  display: grid;
  grid-template-rows: auto 6px auto 6px auto 20px auto;
  grid-template-areas: 'icon' '.' 'title' '.' 'subtitle' '.' 'button';
  grid-template-columns: 1fr;
  width: 100%;
  justify-items: center;
`;

const Title = styled(Typography)`
  grid-area: title;
  color: ${({ theme }) => theme.palette.text.primary};

  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.4px;
`;

const Subtitle = styled(Typography)`
  grid-area: subtitle;
`;

export interface EmptyStateProps {
  Icon?: React.ElementType<SvgIconProps>;
  title: string;
  subtitle: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  children,
  Icon,
  title,
  subtitle,
}) => {
  return (
    <Container>
      {Icon && (
        <Icon
          sx={{
            color: 'grey.400',
            gridArea: 'icon',
            fontSize: '36px !important',
          }}
        />
      )}
      <Title>{title}</Title>
      <Subtitle variant='body1'>{subtitle}</Subtitle>
      {children}
    </Container>
  );
};

export default EmptyState;
